import * as React from 'react';
import styled from 'styled-components';
import { useMutation } from 'urql';

import * as colors from '../../shared/colors';
import RenderMark from '../../shared/components/RenderMark';
import HeartIcon from '../../shared/components/icons/teamScanIcons/HeartIcon';
import { formatYMD, parseDate } from '../../shared/dateFns';
import { IData, ILikeArgs, ILikeData, mutation } from './query';

interface IProps {
    inspiration: IData['learningPath']['inspirations'][0];
}

interface IBox {
    $new: boolean;
}

const Box = styled.div<IBox>`
    border-radius: 1rem;
    margin-bottom: 1rem;
    padding: 1rem;
    padding-top: 0.5rem;
    border: ${({ $new }) => $new ? '3px solid ' + colors.primaryColor : '1px solid black'};
`;

const InspContent = styled(RenderMark)`
    & > * {
        max-width: 100%;
    }
    & > *:last-child {
        margin-bottom: 0;
    }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
`;

const Like = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    svg {
        cursor: pointer;
        width: 2rem;
        height: 2rem;
    }
`;

function Inspiration({ inspiration }: IProps): JSX.Element {
    const [LikeResult, executeMutation] = useMutation<ILikeData, ILikeArgs>(mutation);

    const toggleLike = async () => {
        if (LikeResult.fetching) {
            return;
        }
        const to = inspiration.liked ? 'unlike' : 'like';
        await executeMutation({ id: inspiration.id, to });
    };

    return <Box key={inspiration.id} $new={!inspiration.read}>
        <Header>
            <Like>
                <span>{inspiration.likeCount}</span>
                <HeartIcon active={inspiration.liked} onClick={toggleLike} />
            </Like>
            {inspiration.created && <span>
                {formatYMD(parseDate(inspiration.created))}
            </span>}
        </Header>
        <InspContent content={inspiration.content} />
    </Box>;
}

export default Inspiration;
